import { useSelector } from 'react-redux'

import { useGetPolicyQuery, useGetUserQuery } from 'common'
import { isUserGroupsEnabledSelector } from 'features/user_groups'
import {
  hasAnyUserGroupsSelector,
  userGroupsWhereAdminSelector,
  isFilteringSelector,
  usersSelector,
  policySelector
} from 'selectors/home_bar'

import PrimaryList from './primary_list'
import TeamsList from './teams_list'
import UserGroupList from './user_group_list'
import UserGroupsList from './user_groups_list'
import UsersList from './users_list'

const List = () => {
  const isFiltering = useSelector(isFilteringSelector)
  const { scopes } = useSelector(policySelector)
  const { data: { canCreateTeam, canManageInvitation } } = useGetPolicyQuery()
  const { data: currentUser } = useGetUserQuery()
  const {
    is_user_group_admin: isGroupAdmin,
    user_group_relationships: userGroupRelationships,
    organization_membership: {
      is_admin_or_owner: isAdminOrOwner
    } = {}
  } = currentUser
  const dropdownEntityGroups = Object.keys(scopes).filter((k) => scopes[k])

  const shouldRenderTeams = dropdownEntityGroups.includes('page')

  const userGroupsEnabled = useSelector(isUserGroupsEnabledSelector)
  const anyUserGroups = useSelector(hasAnyUserGroupsSelector)

  const allUserGroupsWhereAdmin = Object.values(userGroupRelationships || []).filter((rel) => rel.admin)
  const userGroupAdminOfMultipleGroups = isGroupAdmin && allUserGroupsWhereAdmin.length > 1
  const filteredUserGroupsWhereAdmin = useSelector(userGroupsWhereAdminSelector)
  const filteredUsers = useSelector(usersSelector)

  const shouldShowAllUsers = dropdownEntityGroups.includes('all_users')
  const shouldRenderUsers = shouldShowAllUsers
    || userGroupAdminOfMultipleGroups
    || (filteredUserGroupsWhereAdmin.length === 0 && filteredUsers.length > 0)
  const shouldRenderOneUserGroup = !shouldRenderUsers
    && userGroupsEnabled
    && isGroupAdmin
    && filteredUserGroupsWhereAdmin.length === 1
    && filteredUsers.length > 0
  const shouldRenderManyUserGroups = anyUserGroups
    && userGroupsEnabled
    && (
      isAdminOrOwner
      || userGroupAdminOfMultipleGroups
      || (filteredUserGroupsWhereAdmin.length > 0 && filteredUsers.length === 0)
    )

  return (
    <>
      {!isFiltering && (
        <PrimaryList
          shouldRenderUsersAndTeams={shouldShowAllUsers && shouldRenderTeams}
        />
      )}
      {shouldRenderOneUserGroup && (
        <UserGroupList
          userGroup={filteredUserGroupsWhereAdmin[0]}
        />
      )}
      {shouldRenderManyUserGroups && (
        <UserGroupsList
          canCreateNewGroups={isAdminOrOwner && !isGroupAdmin}
        />
      )}
      {shouldRenderUsers && (
        <UsersList
          shouldShowAll={shouldShowAllUsers}
          canManageInvitation={canManageInvitation}
        />
      )}
      {shouldRenderTeams && (
        <TeamsList
          canCreateTeam={canCreateTeam}
          isAdminOrOwner={isAdminOrOwner}
        />
      )}
    </>
  )
}

export default List
